import $ from 'jquery';

export class CncSvgAnalyzer {
  private width: number;
  private height: number;
  private totalLength = 0;
  private fullArea = 0;
  private closedLines = 0;
  private notClosedLines = 0;
  private outSvg = '';
  private scale = 100;

  constructor(private svg: string, private thumbSize = 50) {}

  public get _outSvg() {
    return this.outSvg;
  }

  public get _fullArea() {
    return this.fullArea;
  }

  public get _closedLines() {
    return this.closedLines;
  }

  public get _notClosedLines() {
    return this.notClosedLines;
  }

  public get _width() {
    return this.width;
  }

  public get _height() {
    return this.height;
  }

  public get _totalLength() {
    return this.totalLength;
  }

  private parse() {
    const $s = $(this.svg);
    $s.find("path[d='']").remove();
    this.svg = $('<div>').append($s).html();

    // @ts-ignore
    this.width = $s[2].viewBox.baseVal.width;
    // @ts-ignore
    this.height = $s[2].viewBox.baseVal.height;

    const max = this.width > this.height ? this.width : this.height;
    const line = max * 0.0015;
    const tolerance = line * 1e-2;

    this.svg = this.unitePaths(this.svg, tolerance);
    const $svg = $(this.svg);
    const $pathList = $svg.find('path');

    //Calculated parameters:
    let totalLength = 0.0;
    for (let i2 = 0, l2 = $pathList.length; i2 < l2; i2++) {
      totalLength += $pathList[i2].getTotalLength();
    }
    this.totalLength = totalLength;

    const $closedPaths = $svg.find('.closed-path');
    this.fullArea = this.calculateFullArea($closedPaths);

    return $svg;
  }

  parseForThumbnail() {
    const $svg = this.parse();
    let xfactor = this.width / this.height;
    xfactor = xfactor > 1.0 ? 1.0 : xfactor;
    let yfactor = this.height / this.width;
    yfactor = yfactor > 1.0 ? 1.0 : yfactor;
    $svg.addClass('svg-thumbnail');
    $svg.attr('width', this.thumbSize * xfactor);
    $svg.attr('height', this.thumbSize * yfactor);
    this.outSvg = $('<div>').append($svg).html();
  }

  parseForPanZoom() {
    const $svg = this.parse();
    const kerf = 0.635;
    const factor = this.scale / 100.0;
    let thickness = kerf / factor;

    //min thickness 0.15%
    const l = this.width > this.height ? this.width : this.height;
    thickness = thickness / l < 0.0015 ? l * 0.0015 : thickness;
    thickness = l * 0.0015;
    $svg.find('path').attr('stroke-width', thickness);
    this.outSvg = $('<div>').append($svg).html();
  }

  isPointInPoly(poly, pt) {
    let c, i, j, l;

    for (c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i)
      ((poly[i].y <= pt.y && pt.y < poly[j].y) || (poly[j].y <= pt.y && pt.y < poly[i].y)) &&
        pt.x < ((poly[j].x - poly[i].x) * (pt.y - poly[i].y)) / (poly[j].y - poly[i].y) + poly[i].x &&
        (c = !c);

    return c;
  }

  areaFromCoords(t) {
    let e = 0;
    for (let n = t.length, a = 0; a < n; a += 1) {
      const i = t[a],
        r = t[(a - 1 + n) % n];
      e += (r.x + i.x) * (r.y - i.y);
    }
    return Math.abs(e / 2);
  }

  polygonSampledFromPath(t) {
    const n = t.ownerDocument.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    let p = t.getAttribute('d');

    p = p.replace('M', '');
    p = p.replace('Z', ''); //Removes close path command
    const a = p.split('L');

    return n.setAttribute('points', a.join(' ')), n;
  }

  calculateFullArea(pathList) {
    let totalArea = 0.0;
    const polygons = [];
    for (let i = 0, l = pathList.length; i < l; i++) {
      polygons.push(this.polygonSampledFromPath(pathList[i]));
    }

    for (let i = 0, l = pathList.length; i < l; i++) {
      let ar = this.areaFromCoords(polygons[i].points);
      const point = polygons[i].points[0];
      let insideCount = 0;
      for (let j = 0; j < l; j++) {
        //Do not compare to itself
        if (j == i) {
          continue;
        }
        if (this.isPointInPoly(polygons[j].points, point)) {
          insideCount++;
        }
      }
      if (insideCount % 2) {
        ar = ar * -1;
      }

      totalArea += ar;
    }

    return totalArea;
  }

  getDistance(point1, point2) {
    let xs = 0;
    let ys = 0;

    xs = point2.x - point1.x;
    xs = xs * xs;

    ys = point2.y - point1.y;
    ys = ys * ys;

    return Math.sqrt(xs + ys);
  }

  reversePath(p) {
    p = p.replace('M', '');
    const a = p.split('L');
    a.reverse();
    let p2 = a.join('L');
    const m = 'M';
    p2 = m.concat(p2);
    return p2;
  }

  removeM(p) {
    p = p.replace('M', '');
    const a = p.split('L');
    a.shift();
    let p2 = a.join('L');
    const l = 'L';
    p2 = l.concat(p2);
    return p2;
  }

  unitePaths(svg, tolerance) {
    const $s = $(svg);
    const $pl = $s.find('path');

    let united = false;
    for (let i = 0, l = $pl.length; i < l; i++) {
      const t1 = $pl[i].getTotalLength();
      const p1 = $pl[i].getPointAtLength(0.0);
      const p2 = $pl[i].getPointAtLength(t1);

      //check if the path is closed already
      const p1p2 = this.getDistance(p1, p2);
      if (p1p2 < tolerance) {
        continue;
      }

      for (let j = i + 1; j < l; j++) {
        const t2 = $pl[j].getTotalLength();
        const p3 = $pl[j].getPointAtLength(0.0);
        const p4 = $pl[j].getPointAtLength(t2);

        //> 1e-5
        const p2p3 = this.getDistance(p2, p3);
        const p2p4 = this.getDistance(p2, p4);
        const p1p4 = this.getDistance(p1, p4);
        const p1p3 = this.getDistance(p1, p3);

        if (p2p3 < tolerance || p2p4 < tolerance || p1p4 < tolerance || p1p3 < tolerance) {
          if (p2p3 < tolerance) {
            const path1 = $pl[i].getAttribute('d');
            const path2 = this.removeM($pl[j].getAttribute('d'));
            $pl[i].setAttribute('d', path1 + path2);
          } else if (p2p4 < tolerance) {
            const path1 = $pl[i].getAttribute('d');
            let path2 = this.reversePath($pl[j].getAttribute('d'));
            path2 = this.removeM(path2);
            $pl[i].setAttribute('d', path1 + path2);
          } else if (p1p3 < tolerance) {
            const path1 = this.reversePath($pl[j].getAttribute('d'));
            const path2 = this.removeM($pl[i].getAttribute('d'));
            $pl[i].setAttribute('d', path1 + path2);
          } else if (p1p4 < tolerance) {
            const path1 = $pl[j].getAttribute('d');
            const path2 = this.removeM($pl[i].getAttribute('d'));
            $pl[i].setAttribute('d', path1 + path2);
          }

          $pl[j].setAttribute('class', 'to-remove');
          united = true;
          break;
        }
      }

      if (united) {
        break;
      }
    }

    if (united) {
      const $r = $s.find('.to-remove');
      $r.remove();
      return this.unitePaths($('<div>').append($s).html(), tolerance);
    } else {
      this.closedLines = 0;
      this.notClosedLines = 0;
      for (let i = 0, l = $pl.length; i < l; i++) {
        const t1 = $pl[i].getTotalLength();
        const p1 = $pl[i].getPointAtLength(0.0);
        const p2 = $pl[i].getPointAtLength(t1);
        //if the path is Not closed
        const d = this.getDistance(p1, p2);
        if (d >= tolerance) {
          this.notClosedLines++;
          $pl[i].setAttribute('stroke', 'green');
        } else {
          //Add close path 'Z' command
          $pl[i].setAttribute('d', $pl[i].getAttribute('d').concat('Z'));
          $pl[i].setAttribute('class', 'closed-path');
          this.closedLines++;
        }

        // $($pl[i]).append('<title>' + d + ' ' + i +': (' + p1.x + ', '+ p1.y + ')(' + p2.x + ', '+ p2.y + ')</title>')
      }

      return $('<div>').append($s).html();
    }
  }
}
